module.exports = __webpack_public_path__ + "static/media/mail3.d40e1851.ico";